<template>
    <div>
        <div class="align-items-end justify-content-between">
            <button :disabled="!dataProduct.canBeOrdered" class="btn btn-primary" @click="addToCart">
                Add to cart
            </button>
            <a v-if="config.modules.buy_now && dataProduct.canBeOrdered" class="btn btn-light" :href="dataProduct.buyNow"><i class="uil uil-credit-card"></i></a>
        </div>
    </div>
</template>

<script>
    import store from "../CartStore";
    export default {
        props: ['dataProduct'],
        store: store,
        data() {
            return {
                t: t,
                config: config,
                settings: settings,
            };
        },
        methods: {
            ...Vuex.mapActions(['addProduct']),
            addToCart() {
                this.dataProduct.qty = 1
                this.addProduct(this.dataProduct);
            },
        },
    }
</script>
